import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { SCREENS } from '../../../../../constants/screens';
import CustomRoute from '../../../../components/CustomRoute/CustomRoute';
import ReportsScreen from '../../ReportsScreen';
import SalesPeriod from '../../screens/SalesPeriod/SalesPeriod';
import SalesLocation from '../../screens/SalesLocation/SalesLocation';
import SalesDetails from '../../screens/SalesDetails/SalesDetails';

const ReportsNavigation = () => {
  return (
    <React.Fragment>
      <Switch>
        <Route path={SCREENS.REPORTS()} component={ReportsScreen} exact />
        <CustomRoute path={[SCREENS.HOURS_SALES(), SCREENS.DAY_WEEK_SALES(), SCREENS.MONTH_YEAR_SALES()]} component={SalesPeriod} />
        <CustomRoute path={[SCREENS.BRANCH_SALES(), SCREENS.AREA_SALES()]} component={SalesLocation} />
        <CustomRoute
          path={[
            SCREENS.CALL_CENTER_AGENT_SALES(),
            SCREENS.ITEM_SALES(),
            SCREENS.PAYMENT_METHOD_SALES(),
            SCREENS.ORDERING_CHANNEL_SALES(),
            SCREENS.COMBO_SALES(),
          ]}
          component={SalesDetails}
        />
      </Switch>
    </React.Fragment>
  );
};

export default ReportsNavigation;
